<template>

  <modalo
    :title="dashboard.name"
    type="mini"
    @hideModal="hideModal()"
    :modaloWatch="() => dashboard">

    <form
      id="dashboard-form"
      v-on:submit.prevent="saveDashboard(dashboard)">
      <div class="form-group">
        <label>{{ $t('Name') }}</label>
        <input
          v-autofocus
          type="text"
          class="form-control"
          v-model="dashboard.name" maxlength="60">
        <ValidateMessage :error="validateErrors.name" />
      </div>
      <div class="form-group">
        <div class="form-check">
          <input
            class="form-check-input"
            type="checkbox"
            id="advanced"
            v-model="dashboard.advanced">
          <label
            class="form-check-label"
            for="advanced">
            Avançado
          </label>
        </div>
      </div>
      <p>Relatórios avançados só poderão ser visualizados por usuários com essa permissão.</p>
    </form>

    <template slot="footer">
      <div :class="{'box-loading': loading}">
        <button
          type="submit"
          form="dashboard-form"
          class="btn btn-primary">{{ $t('Save') }}</button>
        <button
          type="button"
          class="btn btn-light"
          @click="hideModal()">{{ $t('Cancel') }}</button>
      </div>
    </template>

  </modalo>

</template>

<script>
export default {
  name: 'DashboardForm',
  components: {
  },
  props: [
    'initDashboard'
  ],
  data () {
    return {
      loading: false,
      dashboard: this.defaultValues(this.initDashboard),
      validateErrors: {}
    }
  },
  created () {
  },
  methods: {
    /*
    defaultValues
    */
    defaultValues (values) {
      return values._id
      ? this.$clone(values)
      : Object.assign({
      }, values)
    },
    /*
    hideModal
    */
    hideModal () {
      this.$emit('hideModal')
    },
    /*
    saveDashboard
    */
    saveDashboard (data) {
      if (data._id) this.updateDashboard(data)
      else this.createDashboard(data)
    },
    /*
    createDashboard
    */
    createDashboard (data) {
      this.loading = true

      this.$store
      .dispatch('createDashboard', data)
      .then((result) => {
        this.loading = false
        this.$emit('saved')
      })
      .catch((err) => {
        this.loading = false
        if (err.response.data.name === 'ValidationError') {
          this.validateErrors = err.response.data.errors
        }
      })
    },
    /*
    updateDashboard
    */
    updateDashboard (data) {
      this.loading = true

      this.$store
      .dispatch('updateDashboard', data)
      .then((result) => {
        this.loading = false
        this.$emit('saved')
      })
      .catch((err) => {
        this.loading = false
        if (err.response.data.name === 'ValidationError') {
          this.validateErrors = err.response.data.errors
        }
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/DashboardForm.vue